<div class="container">
  <div class="py-5 text-center">
    <img src="../../../assets/img/thumbnail_Flygets-logo.png" class="d-block margin" alt="Flygets logo-retina">
    <h2>Tyvärr gick någonting gick fel i kommunikationen med banken.</h2>
    <p class="lead">Vi kontrollerar vad som kan ha gått fel men detta kan ta upp till 5 minuter.<br>
      Om du ser att pengarna dragits från ditt konto, ladda om denna sida om ett tag.<br>
      Om pengarna inte dragits försök igen genom att klicka på knappen nedan.</p>
    <button mat-raised-button color="primary" [routerLink]="['/flygets/checkout/payment', order.orderId]">Tillbaka till
      betalning
    </button>
  </div>